import { useInfiniteQuery } from '@tanstack/react-query';

import { MY_ASSETS } from '@/shared/lib/constants';
import { miscKeys } from '@/shared/lib/query/queryKeys';

import { fetchMyAssets } from '@/features/my-assets/api';

export const useMyAssets = () => {
  return useInfiniteQuery({
    queryKey: miscKeys.myAssets(),
    queryFn: ({ pageParam = 0 }) => fetchMyAssets(pageParam, MY_ASSETS.PAGE_SIZE),
    getNextPageParam: (lastPage) => lastPage.nextPage,
    initialPageParam: 0,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};
